var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/stock-output.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-e8f7525e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/stock-output.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/StockOutput.vue
// module id = 722
// module chunks = 1